import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import FontPairPreset from './font-pair-preset';
import getCompiledFontPairConfig from '../helpers/get-compiled-font-pair-config';

const { Box, Stack, Heading } = designSystem;

const FontPairsPresetsGroup = ({
  fonts,
  activeFontId,
  setActiveFont,
  fontObserver,
  title = '',
  onEditClick = null,
  onDeleteClick = null,
  editLabel = '',
  deleteLabel = '',
}) => (
  <div>
    {title && (
      <Box paddingBottom="spacing-2-xs">
        <Heading type="heading-6">{title}</Heading>
      </Box>
    )}
    <Stack gap="spacing-xs">
      {fonts.map((font) => {
        const compiledFont = font.isCustom ? getCompiledFontPairConfig(font) : font;

        return (
          <FontPairPreset
            key={compiledFont.id}
            id={compiledFont.id}
            title={compiledFont.label}
            previewUrl={compiledFont.previewUrl}
            isSelected={compiledFont.id === activeFontId}
            onClick={setActiveFont}
            observer={fontObserver}
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
            editLabel={editLabel}
            deleteLabel={deleteLabel}
            isCustom={compiledFont.isCustom}
            variables={compiledFont.variables}
          />
        );
      })}
    </Stack>
  </div>
);

FontPairsPresetsGroup.propTypes = {
  fonts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isCustom: PropTypes.bool,
    })
  ).isRequired,
  activeFontId: PropTypes.string.isRequired,
  setActiveFont: PropTypes.func.isRequired,
  fontObserver: PropTypes.shape({
    observe: PropTypes.func,
  }).isRequired,
  title: PropTypes.string,
  onEditClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  onDeleteClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  editLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
};

export default FontPairsPresetsGroup;
